import React, { useState } from "react";
import { Phone, X } from "lucide-react";
import SpiracleLogo from "../img/spiracle_logo.png";

const Header = () => {
  const [showServices, setShowServices] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigateTo = (path) => {
    window.location.href = path;
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <div className="hob-top-header">
        <div className="hob-top-header__contacts">
          <span
            onClick={() => (window.location.href = "tel:7506708831")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={16} style={{ marginRight: "0.5rem" }} />
            +91 75067 08831
          </span>

          <span
            onClick={() => (window.location.href = "tel:8530352444")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={16} style={{ marginRight: "0.5rem" }} />
            +91 85303 52444
          </span>
        </div>
      </div>

      <header className="hob-header">
        <div className="hob-header__logo" onClick={() => navigateTo("/")}>
          <img className="logo-width" src={SpiracleLogo} alt="Spiracle Pest Worlds" />
        </div>

        <nav className={`hob-header__nav ${drawerOpen ? "active" : ""}`}>
          <span onClick={() => navigateTo("/")}>Home</span>
          <span onClick={() => navigateTo("/about-us")}>About</span>

          <div
            className="hob-header__nav-services"
            onMouseEnter={() => setShowServices(true)}
            onMouseLeave={() => setShowServices(false)}
          >
            <span onClick={() => navigateTo("/all-services")}>Services</span>
            {/* {showServices && (
                            <ul className="hob-header__nav-services-dropdown">
                                <li onClick={() => navigateTo("/cockroach-control")}>Cockroach Control</li>
                                <li onClick={() => navigateTo("/termite-control")}>Termite Control</li>
                                <li onClick={() => navigateTo("/bed-bug-control")}>Bed Bug Control</li>
                                <li onClick={() => navigateTo("/rodent-control")}>Rodent Control</li>
                                <li onClick={() => navigateTo("/mosquito-control")}>Mosquito Control</li>
                                <li onClick={() => navigateTo("/general-pest-control")}>General Pest Control</li>
                            </ul>
                        )} */}
          </div>
          <span onClick={() => navigateTo("/gallery")}>Gallery</span>
          <span onClick={() => navigateTo("/contact-us")}>Contact</span>
        </nav>

        <button
          className="hob-header__call-button"
          onClick={() => (window.location.href = "tel:8530352444")}
          style={{ cursor: "pointer" }}
        >
          <Phone size={18} style={{ marginRight: "0.5rem" }} />
          Call Now
        </button>

        {/* hob-Hamburger icon for mobile */}
        <div className="hob-hamburger-icon" onClick={toggleDrawer}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {/* Drawer navigation */}
      <div className={`hob-drawer ${drawerOpen ? "hob-open" : ""}`}>
        <div className="hob-drawer-content">
          <button className="hob-drawer-close-btn" onClick={toggleDrawer}>
            <X size={20} />
          </button>
          <nav className="hob-header__nav">
            <span onClick={() => navigateTo("/")}>Home</span>
            <span onClick={() => navigateTo("/about-us")}>About</span>

            {/* <div className="hob-header__nav-services-mobile">
              <span onClick={() => setShowServices(!showServices)}>
                Services{" "}
                {showServices ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                )}
              </span>
              {showServices && (
                <ul className="hob-header__nav-services-dropdown-mobile">
                  <li onClick={() => navigateTo("/cockroach-control")}>
                    Cockroach Control
                  </li>
                  <li onClick={() => navigateTo("/termite-control")}>
                    Termite Control
                  </li>
                  <li onClick={() => navigateTo("/bed-bug-control")}>
                    Bed Bug Control
                  </li>
                  <li onClick={() => navigateTo("/rodent-control")}>
                    Rodent Control
                  </li>
                  <li onClick={() => navigateTo("/mosquito-control")}>
                    Mosquito Control
                  </li>
                  <li onClick={() => navigateTo("/general-pest-control")}>
                    General Pest Control
                  </li>
                </ul>
              )}
            </div> */}

            <span onClick={() => navigateTo("/all-services")}>Services</span>
            <span onClick={() => navigateTo("/gallery")}>Gallery</span>
            <span onClick={() => navigateTo("/contact-us")}>Contact</span>
          </nav>
          <button
            className="hob-header__call-button-mobile"
            onClick={() => (window.location.href = "tel:8530352444")}
          >
            <Phone size={18} style={{ marginRight: "0.5rem" }} />
            Call Now
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;
